const PREFIX = "laundry_page_state_";

function normalizePageNum(value) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : null;
}

function normalizePageSize(value) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : null;
}

export function savePageState(key, { pageNum, pageSize } = {}) {
  if (!key) {
    return;
  }
  const state = {};
  const normalizedPageNum = normalizePageNum(pageNum);
  const normalizedPageSize = normalizePageSize(pageSize);
  if (normalizedPageNum != null) {
    state.pageNum = normalizedPageNum;
  }
  if (normalizedPageSize != null) {
    state.pageSize = normalizedPageSize;
  }
  if (!Object.keys(state).length) {
    return;
  }
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(state));
  } catch (e) {
    // ignore quota / privacy mode errors
  }
}

export function loadPageState(key) {
  if (!key) {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) {
      return null;
    }
    const data = JSON.parse(raw);
    const state = {};
    const normalizedPageNum = normalizePageNum(data.pageNum);
    const normalizedPageSize = normalizePageSize(data.pageSize);
    if (normalizedPageNum != null) {
      state.pageNum = normalizedPageNum;
    }
    if (normalizedPageSize != null) {
      state.pageSize = normalizedPageSize;
    }
    return Object.keys(state).length ? state : null;
  } catch (e) {
    return null;
  }
}

export function clearPageState(key) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch (e) {
    // ignore
  }
}
